import request from '@/utils/request';
import Resource from '@/api/resource';
class AdvertiserResource extends Resource {
  constructor() {
    super('advertiser');
  }

  // 同步广点通历史数据
  updateGdtSource() {
    return request({
      url: `${this.uri}/gdt/syncHistory`,
      method: 'get',
    });
  }

  /** 同步头条历史数据 */
  updateJrttSource() {
    return request({
      url: `${this.uri}/jrtt/syncHistory`,
      method: 'get',
    });
  }

  /** 获取纵横组织下资产账户列表接口 */
  getMajordomoAdvertiser(data) {
    return request({
      url: `${this.uri}/jrtt/getMajordomoAdvertiser`,
      method: 'get',
      params: data,
    });
  }
}
export { AdvertiserResource as default };
